var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-right 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0596 14.5C13.7561 14.2125 13.4394 13.9183 13.1095 13.604C14.0728 12.6345 15.0163 11.6783 16.006 10.6753H2.5V9.30461H15.94C14.9833 8.34175 14.0398 7.38559 13.0897 6.41605C13.4526 6.08172 13.7693 5.78083 14.0728 5.5C15.5177 6.96434 17.0221 8.48886 18.5 9.98663C17.0353 11.471 15.5309 12.9955 14.053 14.4933L14.0596 14.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.3dc1dc209db77e5c7b022fd9ac5aa6f3.svg";
export { ForwardRef as ReactComponent };